export default __webpack_public_path__ + "static/media/banner 2.813b2ffc.png";